module.exports = __webpack_public_path__ + "img/party.4dc257cf.svg";